export default function ValidateRegulations(form) {
  let error = {};

  if (!form.regulations) {
    error.regulations = "Proszę zaakceptować regulamin.";
  }

  return error;
};